import { Component, input, output } from '@angular/core';
import { UserAvatarComponent } from '../../user-avatar/user-avatar.component';
import { environment } from '../../../../../environments/environment';
import { User, UserTypes } from '../../../types/user.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-my-forest-list',
  imports: [UserAvatarComponent, TranslatePipe],
  templateUrl: './my-forest-list.component.html',
  styleUrl: './my-forest-list.component.scss'
})
export class MyForestListComponent {
  public userTypes = UserTypes;
  readonly list = input<User[]>([]);
  readonly userClick = output<User>();

  public getInitials(user: User): string {
    const { firstName, lastName } = user;
    return [firstName, lastName].map((name: string) => name?.charAt(0)?.toUpperCase() || '').join('');
  }

  public getAvatarUrl(user: User): string {
    if (!user?.avatar?.image) {
      return '';
    }
    return environment.avatarsUrl + 'Property_1=' + user?.avatar?.image;
  }

  onMemberClick(user: User): void {
    this.userClick.emit(user);
  }
}
